import { createSlice } from '@reduxjs/toolkit';
import { initialUSpaceState } from 'reducers/initialStates';

const uspaceSlice = createSlice({
	name: 'uspace',
	initialState: {
		//Set by configureStore
	},
	reducers: {
		resetUSpaceSlice() {
			return initialUSpaceState;
		},

		// UI State Actions
		setCurrentStep(state, action) {
			state.currentStep = action.payload;
		},
		setCheckResult(state, action) {
			state.checkResult = action.payload;
		},
		setEditMode(state, action) {
			state.editMode = action.payload;
		},

		// Payload Actions
		setPayload(state, action) {
			state.payload = action.payload;
		},
		updatePayloadField(state, action) {
			const { field, value } = action.payload;
			if (!state.payload) state.payload = {};
			state.payload[field] = value;
		},

		// Form State Actions (not part of API payload)
		updateFormState(state, action) {
			const { field, value } = action.payload;
			state[field] = value;
		},

		// Validation Actions
		setFrontEndValidationErrors(state, action) {
			state.frontEndValidationErrors = action.payload;
		},
		clearFrontEndValidationErrors(state) {
			state.frontEndValidationErrors = {};
		},
		setBackEndValidationErrors(state, action) {
			state.backEndValidationErrors = action.payload;
		},
		clearBackEndValidationErrors(state) {
			state.backEndValidationErrors = [];
		},
		// Used for entering edit mode - populates entire payload
		hydrateUSpace(state, action) {
			if (action.payload.editMode) {
				state.editMode = action.payload.editMode;
			}
			if (action.payload.payload) {
				state.payload = action.payload.payload;
			}
		},

		// Used for duplicating U-space authorization
		setDuplicateUSpace(state, action) {
			return {
				...state,
				...action.payload
			};
		}
	}
});

export const {
	resetUSpaceSlice,
	setCurrentStep,
	setCheckResult,
	setEditMode,
	setPayload,
	updatePayloadField,
	updateFormState,
	setFrontEndValidationErrors,
	clearFrontEndValidationErrors,
	setBackEndValidationErrors,
	hydrateUSpace,
	setDuplicateUSpace,
	clearBackEndValidationErrors
} = uspaceSlice.actions;

export default uspaceSlice.reducer;

export const uspaceCheckResultSelector = state => state.uspace.checkResult;
export const uspacePayloadSelector = state => state.uspace.payload;
export const uspaceEditModeSelector = state => state.uspace.editMode;
export const uspaceCurrentStepSelector = state => state.uspace.currentStep;
export const uspaceFrontEndValidationErrorsSelector = state =>
	state.uspace.frontEndValidationErrors;
export const uspaceBackEndValidationErrorsSelector = state => state.uspace.backEndValidationErrors;
export const uspaceUserSelector = state => state.uspace.user;
export const uspaceAircraftSelector = state => state.uspace.aircraft;
